import type { LandingCopy } from './copy';

/** Who it's for, then what a distributor gets: the first thing a visitor reads after the hero. */
export const Why = ({ who, why }: { who: LandingCopy['who']; why: LandingCopy['why'] }) => (
  <section id="why" className="lp-section lp-section--alt">
    <div className="lp-container">
      <div className="lp-who">
        <h2>{who.title}</h2>
        <ul className="lp-who__list">
          {who.points.map((point) => (
            <li key={point}>{point}</li>
          ))}
        </ul>
      </div>

      <h2 className="lp-why__title">{why.title}</h2>
      <p className="lp-section__intro">{why.intro}</p>
      <ul className="lp-reliability lp-why">
        {why.items.map((item) => (
          <li key={item.title}>
            <h3>{item.title}</h3>
            <p>{item.body}</p>
          </li>
        ))}
      </ul>
    </div>
  </section>
);
